import { Middleware } from 'redux';
import * as Actions from '../actions';
import RootState from '../RootState';
import TourStep from '../../tour/TourSteps';

const handler: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    next(action);
    const { tourIndex } = (store.getState() as RootState).app;
    const type = action.type;
    if (tourIndex > -1) {
      if (
        (type === Actions.BROWSE_EFFECTS && tourIndex === TourStep.AddEffect) ||
        (type === Actions.START_RECORDING &&
          tourIndex === TourStep.RecordVideo) ||
        (type === Actions.RESET && tourIndex === TourStep.CreateNew)
      ) {
        setTimeout(() => {
          store.dispatch(Actions.updateTourStep(tourIndex + 1));
        }, 1);
      }
    }
  };

export default handler;



// WEBPACK FOOTER //
// ./src/state/side-effects/tourUpdate.ts